import { z } from 'zod';
import { AreaSequenceItemStatus } from './AreaSequenceItemStatus.enum';

export const areaSequenceItemStatusUpdateNotificationMetadataSchema = z.object({
	userName: z.string(),
	sequenceItemDescription: z.string(),
	newStatus: z.enum(AreaSequenceItemStatus),
	areasNickName: z.array(z.string()),
});

export type IAreaSequenceItemStatusUpdateNotificationMetadata = z.infer<
	typeof areaSequenceItemStatusUpdateNotificationMetadataSchema
>;
